// src/screens/NotificationsScreen.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/LegalPage.css";

const API_BASE = process.env.REACT_APP_API_URL;

const token =
  typeof window !== "undefined" ? localStorage.getItem("token") : null;
const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

function getIcon(type) {
  if (type?.startsWith("GUEST_BOOKING")) return "✅";
  if (type === "GUEST_TIME_WARNING") return "⏰";
  if (type === "GUEST_THANK_YOU") return "💙";
  if (type === "PARTNER_NEW_BOOKING") return "🧻";
  if (type === "PARTNER_PAYOUT_AVAILABLE") return "💸";
  return "🔔";
}

export default function NotificationsScreen() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState(false);

  useEffect(() => {
    if (!API_BASE || !token) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchNotifications = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE}/notifications`, {
          headers: authHeader,
        });
        if (cancelled) return;
        setNotifications(res.data.notifications || []);
      } catch (err) {
        console.error("GET /notifications error:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchNotifications();
    return () => {
      cancelled = true;
    };
  }, []);

  const markAllRead = async () => {
    if (!API_BASE || !token) return;
    const unreadIds = notifications
      .filter((n) => !n.read)
      .map((n) => n.id);

    if (!unreadIds.length) return;

    try {
      setMarking(true);
      await axios.post(
        `${API_BASE}/notifications/mark-read`,
        { ids: unreadIds },
        { headers: authHeader }
      );
      setNotifications((prev) =>
        prev.map((n) => (unreadIds.includes(n.id) ? { ...n, read: true } : n))
      );
    } catch (err) {
      console.error("POST /notifications/mark-read error:", err);
    } finally {
      setMarking(false);
    }
  };

  return (
    <div className="legal-page">
      <div className="legal-card">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h1>Notifications</h1>
          <button
            type="button"
            onClick={markAllRead}
            disabled={marking || notifications.every((n) => n.read)}
            style={{
              fontSize: "12px",
              padding: "6px 10px",
              borderRadius: "999px",
              border: "1px solid #e5e7eb",
              background: "#f9fafb",
              cursor: "pointer",
            }}
          >
            Mark all as read
          </button>
        </div>

        <p className="legal-meta">
          {loading
            ? "Loading notifications..."
            : notifications.length === 0
            ? "No notifications yet."
            : `${notifications.length} notification${notifications.length > 1 ? "s" : ""}`}
        </p>

        {!loading && notifications.length > 0 && (
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {notifications.map((n) => (
              <li
                key={n.id}
                style={{
                  display: "flex",
                  gap: 12,
                  padding: "10px 0",
                  borderBottom: "1px solid #e5e7eb",
                  opacity: n.read ? 0.7 : 1,
                }}
              >
                <div style={{ fontSize: 20 }}>{getIcon(n.type)}</div>
                <div>
                  <div
                    style={{
                      fontWeight: n.read ? 500 : 600,
                      fontSize: 14,
                      marginBottom: 2,
                    }}
                  >
                    {n.title}
                  </div>
                  <div style={{ fontSize: 13, color: "#4b5563" }}>
                    {n.body}
                  </div>
                  {n.createdAt && (
                    <div
                      style={{
                        fontSize: 11,
                        color: "#9ca3af",
                        marginTop: 2,
                      }}
                    >
                      {new Date(n.createdAt._seconds * 1000).toLocaleString?.() ||
                        ""}
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
